import ToggleWithInputLogic from './ToggleWithInput.logic'

export default ToggleWithInputLogic
